/*global BOOMR*/
define('lib/Podio.Utils',['require','lib/prototype/String.prototype','underscore','jquery','lib/Podio.Config','lib/Podio.Bootstrap','lib/backbone/Backbone.Mixins.Transport.API'],function(require) {

  require('lib/prototype/String.prototype');

  var _ = require('underscore');
  var $ = require('jquery');

  var podioConfig = require('lib/Podio.Config');
  var bootstrap = require('lib/Podio.Bootstrap');

  var API = require('lib/backbone/Backbone.Mixins.Transport.API');

  var cachedOrgs = {};

  function isPresent(value) {
    return typeof(value) != 'undefined' && value !== null && value !== '';
  }

  function querystring() {
    var urlParams = {};
    (function () {
      var e,
              a = /\+/g,  // Regex for replacing addition symbol with a space
              r = /([^&=]+)=?([^&]*)/g,
              d = function (s) {
                return decodeURIComponent(s.replace(a, " "));
              },
              q = window.location.search.substring(1);

      while ((e = r.exec(q))) {
        urlParams[d(e[1])] = d(e[2]);
      }
    })();
    return urlParams;
  }

  function getQueryStringByParams(url, params){
    params = params || {};

    if(_.size(params)){
      params = _.map(params, function(value, key) {
        return  encodeURIComponent(key) + '=' + encodeURIComponent(value);
      });

      params = params.join('&');
      url += '?' + params;
    }

    return url;
  }

  function getQueryStringAsObject() {
    var urlParams = {};
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    /*jshint boss:true */
    while (match = search.exec(query)) {
       urlParams[decode(match[1])] = decode(match[2]);
    }

    return urlParams;
  }

  function showFeature(feature) {
    if (podioConfig.activeFeatures) {
      return $.inArray(feature, podioConfig.activeFeatures) > -1;
    } else {
      return false;
    }
  }

  function inSplitTest(experimentName, value) {
    if (_.isUndefined(podioConfig.user) || _.isUndefined(podioConfig.user.splitTests)) {
      return false;
    }

    return podioConfig.user.splitTests[experimentName] === value;
  }

  function splitTest(experimentName) {
    return podioConfig.user.splitTests[experimentName];
  }

  function loggedIn() {
    if (podioConfig.user && podioConfig.user.name) {
      return podioConfig.user.name !== null && podioConfig.user.name !== '';
    } else {
      return false;
    }
  }

  function addQueryString(url, query, value) {
    if (_.isEmpty(url)) {
      return url;
    }

    var urlParts = url.split('#');
    var hash = urlParts[1];
    var baseUrl = urlParts[0];

    var newUrl = baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') + query + '=' + value;

    return '{0}{1}'.format( newUrl, hash ? '#' + hash : '' );
  }

  // LEGACY FUNCTION. Only used for app views
  // Use item values model to format duration fields
  function secondsToDate(value, fields) {
    fields = fields || ['hours', 'minutes', 'seconds'];

    if (_.isNull(value) || _.isNaN(value) || _.isUndefined(value)) {
      return [null, null, null, null];
    }

    var secondsInDay = 60 * 60 * 24;
    var secondsInHour = 60 * 60;
    var secondsInMinute = 60;

    var days = Math.floor(value/secondsInDay);
    var hours = Math.floor((value - (days * secondsInDay))/secondsInHour);
    var minutes = Math.floor((value - (days * secondsInDay) - (hours * secondsInHour))/secondsInMinute);
    var seconds = Math.round(value - (days * secondsInDay) - (hours * secondsInHour) - (minutes * secondsInMinute));

    if (!_.include(fields, 'days')) {
      hours = hours + (days * 24);
      days = null;
    }

    if (!_.include(fields, 'hours')) {
      minutes = minutes + (hours * 60);
      hours = null;
    }

    if (!_.include(fields, 'minutes')) {
      seconds = seconds + (minutes * 60);
      minutes = null;
    }

    if (!_.include(fields, 'seconds')) {
      seconds = null;
    }

    return {
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };

  }

  function plural(value, singularValue, pluralValue) {
    return (value > 1) ? pluralValue : singularValue;
  }

  function abs() {
    return Math.abs(this);
  }

  // Extracted from sugar.js. https://github.com/andrewplummer/Sugar
  // Slightly modified to get rid of abs() dependency
  function round(val, precision, method) {
    var fn = Math[method || 'round'];
    var multiplier = Math.pow(10, Math.abs(precision || 0));
    if(precision < 0) {
      multiplier = 1 / multiplier;
    }
    return fn(val * multiplier) / multiplier;
  }

  function formatNumber(number, forcePrecision) {
    var result;
    // Round to 4 decimals
    result = round(number, 4, 'round');

    // Format separator and delimiter
    if (forcePrecision) {
      result = (result*1.0).toFixed(forcePrecision);
    } else {
      result += '';
    }
    var x = result.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? podioConfig.localeSettings.number.format.separator + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + podioConfig.localeSettings.number.format.delimiter + '$2');
    }
    result = x1 + x2;

    return result;
  }

  function userSpaceIds() {
    return podioConfig.userSpaceIds;
  }

  function isUserInSpace(spaceId) {
    return _.include(userSpaceIds(), spaceId);
  }

  function maxIconId() {
    return 416;
  }

  function getOrgByUrlLabel(){
    var urlLabel = window.location.pathname.split('/')[1];

    if (_.isUndefined(cachedOrgs[urlLabel])) {
      cachedOrgs[urlLabel] = API.request('GET', '/org/url?org_slug={0}'.format(urlLabel));
    }

    return cachedOrgs[urlLabel];
  }

  function getContractByOrg() {
    var dfd = new $.Deferred();

    getOrgByUrlLabel().then(function (organization) {
      var options = {
        ignoreHTTPErrors: true
      };

      API.request('GET', '/contract/org/{0}/user'.format(organization.org_id), void 0, options).done(dfd.resolve).fail(dfd.reject);
    });

    return dfd;
  }

  function getOrganizations(){
    return API.request('GET', '/org/');
  }

  function markUserTime(name, includeWithBeacon) {
    if (window.performance && window.performance.mark) {
      // console.log(name, includeWithBeacon);
      window.performance.mark(name);
      if (window.BOOMR && BOOMR && BOOMR.plugins.RT && includeWithBeacon) {
        setBoomrTimer(name);
        BOOMR.podio_complete = true;
        BOOMR.sendBeacon();
      }
    }
  }

  function setBoomrTimer(name) {
    var marks = window.performance.getEntriesByName(name, "mark");
    if (marks.length == 1) {
      var startTime = Math.round(marks[0].startTime);
      if (startTime >= 0 && startTime < 3600000) {
        // console.log(name + ": sending timer: " + startTime);
        BOOMR.plugins.RT.setTimer("custom0", startTime);
      }
    }
  }

  /*
   * Trigger a reflow by adding and deleting a span to an element
   * @param {object} $elm The jQuery object to append to, and remove from.
   * @returns {undefined}
   */
  function reflowElm($elm) {
    var span = $('<span>').appendTo($elm);
    _.defer(function () {
       span.remove();
    });
  }

  // Run a function for every interval for a limited amount of time
  // Runs for maximum 5 seconds if you forget the time limit
  function timedInterval(fn, interval, timeout) {
    return setTimeout(clearInterval.bind(window, setInterval(fn, interval)), timeout || 5000);
  }

  function generateFilesZipUrl(itemId) {
    return '{0}/file/item/{1}/zip?authenticity_token={2}'.format(podioConfig.endpoints.apiProxy, itemId, podioConfig.authenticity_token());
  }

  function showWorkspaceContacts(spaceModel) {
    return spaceModel.can && spaceModel.can('add_contact');
  }

  function isMetaEvent(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  }

  return {
    isMetaEvent: isMetaEvent,
    isPresent: isPresent,
    querystring: querystring,
    addQueryString : addQueryString,
    getQueryStringAsObject: getQueryStringAsObject,
    showFeature: showFeature,
    inSplitTest: inSplitTest,
    splitTest: splitTest,
    loggedIn: loggedIn,
    secondsToDate: secondsToDate,
    plural : plural,
    round: round,
    formatNumber: formatNumber,
    userSpaceIds: userSpaceIds,
    isUserInSpace: isUserInSpace,
    maxIconId: maxIconId,
    getOrgByUrlLabel: getOrgByUrlLabel,
    getContractByOrg: getContractByOrg,
    getOrganizations: getOrganizations,
    markUserTime: markUserTime,
    reflowElm: reflowElm,
    timedInterval: timedInterval,
    getQueryStringByParams: getQueryStringByParams,
    generateFilesZipUrl: generateFilesZipUrl,
    showWorkspaceContacts: showWorkspaceContacts
  };

});

